import React, { useEffect, useState } from 'react';
import { INSTALLATION_SHOTS } from '../../../assets/installationShots';

const ROTATE_MS = 2000;

export default function ScreenInstallCarousel() {
    const [activeIndex, setActiveIndex] = useState(0);
    const [paused, setPaused] = useState(false);

    useEffect(() => {
        if (paused || INSTALLATION_SHOTS.length <= 1) {
            return undefined;
        }

        const prefersReduced =
            typeof window !== 'undefined' &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (prefersReduced) {
            return undefined;
        }

        const timer = window.setInterval(() => {
            setActiveIndex((i) => (i + 1) % INSTALLATION_SHOTS.length);
        }, ROTATE_MS);

        return () => window.clearInterval(timer);
    }, [paused]);

    function goTo(index) {
        setActiveIndex(index);
    }

    return (
        <div
            className="advertiser-signup-carousel"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
            onFocus={() => setPaused(true)}
            onBlur={() => setPaused(false)}
        >
            <div className="advertiser-signup-carousel-viewport" aria-live="polite">
                {INSTALLATION_SHOTS.map((shot, index) => (
                    <figure
                        key={shot.alt}
                        className={`advertiser-signup-carousel-slide ${index === activeIndex ? 'is-active' : ''}`}
                        aria-hidden={index !== activeIndex}
                    >
                        <img src={shot.src} alt={shot.alt} />
                    </figure>
                ))}
            </div>
            <div className="advertiser-signup-carousel-dots" role="tablist" aria-label="Installation photos">
                {INSTALLATION_SHOTS.map((shot, index) => (
                    <button
                        key={shot.alt}
                        type="button"
                        role="tab"
                        aria-selected={index === activeIndex}
                        aria-label={`Show photo ${index + 1} of ${INSTALLATION_SHOTS.length}`}
                        className={`advertiser-signup-carousel-dot ${index === activeIndex ? 'is-active' : ''}`}
                        onClick={() => goTo(index)}
                    />
                ))}
            </div>
        </div>
    );
}
